function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import l from "./util/net.js";
import ve from "./models/braze-event.js";
import c from "./common/event-logger.js";
import { randomInclusive as a } from "./util/math.js";
import F from "./models/request-result.js";
import { logger as N, IndexedDBAdapter as st, Guid as K, EventTypes as d } from "../shared-lib/index.js";
import { STORAGE_KEYS as s } from "./managers/storage-manager.js";
import u from "./managers/subscription-manager.js";
import vt from "./Push/utils/push-utils.js";
import h from "./util/request-header-utils.js";

var Lt = /*#__PURE__*/function () {
  function Lt(t, i, s, e, h, o, n, r, l, a) {
    _classCallCheck(this, Lt);

    this.an = t, this.baseUrl = i, this.T = s, this.hn = e, this.Cs = h, this.B = o, this.C = n, this.$l = r, this.Pa = l, this.S = a, this.an = t, this.baseUrl = i, this.Tl = 0, this.dE = n.IE() || 0, this.Ml = null, this.T = s, this.hn = e, this.Cs = h, this.B = o, this.C = n, this.Pa = l, this.S = a, this.$l = r, this.Pl = new u(), this.Ol = null, this.Ul = 50, this._l = !1;
  }

  _createClass(Lt, [{
    key: "Kl",
    value: function Kl(t, i) {
      return !t && !i && this.Pa.Kh() >= this.Ul;
    }
  }, {
    key: "Xl",
    value: function Xl(t) {
      var i = this.T.zl();

      if (t.length > 0) {
        var _s = this.Cs.getUserId();

        var _iterator = _createForOfIteratorHelper(t),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var e = _step.value;

            var _t = !e.userId && !_s || e.userId === _s;

            e.type === d.Fl && _t && (i = !0);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      return i;
    }
  }, {
    key: "Ql",
    value: function Ql() {
      var _this = this;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var e = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
      var o = arguments.length > 3 ? arguments[3] : undefined;
      var n = arguments.length > 4 ? arguments[4] : undefined;
      var r = arguments.length > 5 ? arguments[5] : undefined;
      var u = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : !1;
      var c = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : !1;
      e && this.Yl();
      var d = this.C.AE(),
          m = this.C.OE();
      var f = !1;

      var g = function g(t, i) {
        var u = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
        var c = new Date().valueOf();
        h.W(_this.C, h.O.Nu, c), -1 !== u && i.push(["X-Braze-Req-Tokens-Remaining", u.toString()]);
        var d = !1;
        l.Y({
          url: _this.baseUrl + "/data/",
          data: t,
          headers: i,
          tt: function tt(e) {
            null != t.respond_with && t.respond_with.triggers && (_this.Tl = Math.max(_this.Tl - 1, 0)), _this.S.st(t, e, i) ? (_this.Pa.it(), _this.B.gl(e), null != t.respond_with && t.respond_with.user_id != _this.Cs.getUserId() || (null != t.device && _this.C.Bt(s.gt.oc, t.device), null != t.sdk_metadata && (_this.C.Bt(s.gt.pu, t.sdk_metadata), _this.C.Bt(s.gt.Ru, _this.T.St())), _this.$l(e), h.Mu(_this.C, h.O.Nu, 1), "function" == typeof o && o())) : e.auth_error && (d = !0);
          },
          error: function error() {
            d = !0, null != t.respond_with && t.respond_with.triggers && (_this.Tl = Math.max(_this.Tl - 1, 0)), _this.S.gu(t.events, t.attributes), "function" == typeof n && n();
          },
          nt: function nt(t, i) {
            "function" == typeof r && r(!d);

            var s = _this.S.Pu(i);

            var o = 0;
            if (s) switch (s.type) {
              case "date":
                o = Math.max(s.value - new Date().valueOf(), 0);
                break;

              case "timestamp":
                o = s.value;
            }

            if (e && !f) {
              if (d) {
                h.Uu(_this.C, h.O.Nu);
                var _t2 = _this.Ml;
                (null == _t2 || _t2 < 1e3 * _this.dE) && (_t2 = 1e3 * _this.dE);

                var _i = Math.min(3e5, a(1e3 * _this.dE, 3 * _t2)) + o;

                _this.Zl(_i);
              } else _this.Zl(Math.max(1e3 * _this.dE, o));

              f = !0;
            }
          }
        });
      },
          p = this.Xl(d),
          v = i || p;

      if (this.Kl(u, p)) return void N.info("Declining to flush data due to 50 consecutive authentication failures");
      if (e && !this.S.yu(d, m, t, v)) return this.Zl(), void ("function" == typeof r && r(!0));
      var b = this.S.wu(t, v, d, m, c);
      v && this.Tl++;
      var w = !1;

      if (b) {
        var _iterator2 = _createForOfIteratorHelper(b),
            _step2;

        try {
          var _loop = function _loop() {
            var t = _step2.value;
            _this.S.V(t.requestData, function (i) {
              return g(t.requestData, t.headers, i);
            }, h.O.Nu, n), w = !0;
          };

          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }

      this.Pa.jh() && e && !w ? this.Zl() : p && (N.info("Invoking new session subscriptions"), this.Pl.X());
    }
  }, {
    key: "dc",
    value: function dc() {
      return this.Tl > 0;
    }
  }, {
    key: "Zl",
    value: function Zl() {
      var _this2 = this;

      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1e3 * this.dE;
      this._l || (this.Yl(), this.Ol = window.setTimeout(function () {
        if (document.hidden) {
          var _t3 = "visibilitychange",
              i = function i() {
            document.hidden || (document.removeEventListener(_t3, i, !1), _this2.Ql());
          };

          document.addEventListener(_t3, i, !1);
        } else _this2.Ql();
      }, t), this.Ml = t);
    }
  }, {
    key: "Yl",
    value: function Yl() {
      null != this.Ol && (clearTimeout(this.Ol), this.Ol = null);
    }
  }, {
    key: "initialize",
    value: function initialize() {
      this._l = !1, this.Zl();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.Pl.removeAllSubscriptions(), this.Pa.Hh(), this.Yl(), this._l = !0, this.Ql(void 0, void 0, !1, void 0, void 0, void 0, void 0, !0), this.Ol = null;
    }
  }, {
    key: "on",
    value: function on(t) {
      return this.Pl.Dt(t);
    }
  }, {
    key: "openSession",
    value: function openSession() {
      var _this3 = this;

      var t = this.T.St() !== this.T.Qo();
      t && (this.C.TE(s.iu.Na), this.C.TE(s.iu.su)), this.Ql(void 0, !1, void 0, function () {
        _this3.C.Ut(s.gt.Ge);
      }), this.Qn(), t && import("./Push/push-manager-factory.js").then(function (t) {
        if (_this3._l) return;
        var i = t.default.ea();

        if (null != i && (vt.isPushPermissionGranted() || vt.isPushBlocked())) {
          var _t4 = function _t4() {
            i.wn() ? N.info("Push token maintenance is disabled, not refreshing token for backend.") : i.subscribe();
          },
              e = function e(i, s) {
            s && _t4();
          },
              _h = function _h() {
            var i = _this3.C.ft(s.gt.zn);

            (null == i || i) && _t4();
          },
              o = st.Ls.Fs;

          new st(o, N).cr(o.Ms.cu, e, _h);
        }
      });
    }
  }, {
    key: "mc",
    value: function mc() {
      this.C.Ut(s.gt.Xe), this.C.Ut(s.gt.Hs), this.C.Ut(s.gt.Kr);
    }
  }, {
    key: "changeUser",
    value: function changeUser(t, i, e) {
      var h = this.Cs.getUserId();

      if (h !== t) {
        this.T.Il(), this.mc(), null != h && this.Ql(void 0, !1, void 0, void 0, void 0), this.Cs.ou(t), e ? this.Pa.setSdkAuthenticationSignature(e) : this.Pa.Bh();

        for (var _t5 = 0; _t5 < i.length; _t5++) {
          i[_t5].changeUser(null == h);
        }

        this.S.fo(), null != h && this.C.Ut(s.gt.Zt), this.C.Ut(s.gt.oc), this.C.Ut(s.gt._E), this.openSession(), N.info('Changed user to "' + t + '".');
      } else {
        var _i2 = "Doing nothing.";
        e && this.Pa.xh() !== e && (this.Pa.setSdkAuthenticationSignature(e), _i2 = "Updated SDK authentication signature"), N.info("Current user is already ".concat(t, ". ").concat(_i2));
      }
    }
  }, {
    key: "requestImmediateDataFlush",
    value: function requestImmediateDataFlush(t) {
      this.Yl(), this.T.Qo();
      this.Ql(void 0, void 0, void 0, void 0, function () {
        N.error("Failed to flush data, request will be retried automatically.");
      }, t, !0);
    }
  }, {
    key: "requestFeedRefresh",
    value: function requestFeedRefresh() {
      this.T.Qo(), this.Ql(!0);
    }
  }, {
    key: "br",
    value: function br(t, i) {
      this.T.Qo(), N.info("Requesting explicit trigger refresh."), this.Ql(void 0, !0, void 0, t, i);
    }
  }, {
    key: "Cn",
    value: function Cn(t, i) {
      var e = d.fc,
          h = {
        a: t,
        l: i
      },
          o = c.ut(e, h);
      return o && (N.info("Logged alias ".concat(t, " with label ").concat(i)), this.C.Bt(s.gt._E, h)), o;
    }
  }, {
    key: "Ln",
    value: function Ln(t, i, s) {
      if (this.B.hu(i)) return N.info("Custom Attribute \"".concat(i, "\" is blocklisted, ignoring.")), new F();
      var e = {
        key: i,
        value: s
      },
          h = c.ut(t, e);

      if (h) {
        var _t6 = "object" == _typeof(s) ? JSON.stringify(s, null, 2) : s;

        N.info("Logged custom attribute: ".concat(i, " with value: ").concat(_t6));
      }

      return h;
    }
  }, {
    key: "setLastKnownLocation",
    value: function setLastKnownLocation(t, i, s, e, h, o) {
      var n = {
        latitude: i,
        longitude: s
      };
      null != e && (n.altitude = e), null != h && (n.ll_accuracy = h), null != o && (n.alt_accuracy = o);
      var r = c.ut(d.vc, n, t || void 0);
      return r && N.info("Set user last known location as ".concat(JSON.stringify(n, null, 2))), r;
    }
  }, {
    key: "lr",
    value: function lr(t, i) {
      var s = this.T.Qo();
      return new ve(this.Cs.getUserId(), d.bc, t, s, {
        cid: i
      });
    }
  }, {
    key: "wc",
    value: function wc(t, i) {
      return new st(t, i);
    }
  }, {
    key: "Qn",
    value: function Qn() {
      var t = st.Ls.Fs;
      this.wc(t, N).setItem(t.Ms.Nu, 1, {
        baseUrl: this.baseUrl,
        data: {
          api_key: this.an,
          device_id: this.hn.ve().id
        },
        userId: this.Cs.getUserId(),
        sdkAuthEnabled: this.Pa.jh()
      });
    }
  }, {
    key: "vr",
    value: function vr(t) {
      var _iterator3 = _createForOfIteratorHelper(t),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var i = _step3.value;
          if (i.api_key === this.an) this.S.gu(i.events, i.attributes);else {
            var _t7 = st.Ls.Fs;
            new st(_t7, N).setItem(_t7.Ms.kr, K.ce(), i);
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "Kn",
    value: function Kn(t, i, s) {
      if (this.B.hu(t)) return N.info("Custom Attribute \"".concat(t, "\" is blocklisted, ignoring.")), new F();
      var e, h;
      return null === i && null === s ? (e = d.kc, h = {
        key: t
      }) : (e = d.yc, h = {
        key: t,
        latitude: i,
        longitude: s
      }), c.ut(e, h);
    }
  }, {
    key: "Mn",
    value: function Mn(t, i) {
      var s = {
        group_id: t,
        status: i
      };
      return c.ut(d.jc, s);
    }
  }]);

  return Lt;
}();

export { Lt as default };